import { get, post } from '../tools/http';

export default {
    state: {
        cities: [],
        status: {},
        statusList: [],
        actPdfLink: 'https://s3-cms.rsv.ru/legal/bolhse_chem_puteshestvie/act.pdf',
    },
    mutations: {
        writeCities: (state, value) => state.cities = value,
        writeStatus: (state, value) => state.status = value,
        writeStatusList: (state, value) => state.statusList = value,
    },
    actions: {
        async loadTripCities(ctx){
            const response =
                await get(
                    'api-morethantrip',
                    'api/v1/departurecity',
                    true,
                    true
                );

            ctx.commit('writeCities', response.data);

            return response.data;
        },
        async loadStateStatus(ctx){
            const response =
                await get(
                    'api-morethantrip',
                    'api/v1/trip/state',
                    true, 
                    true
                );

            ctx.commit('writeStatus', response);

            return response;
        },
        async loadStateStatusList(ctx){
            const response =
                await get(
                    'api-morethantrip',
                    'api/v1/trip/state/list',
                    true, 
                    true
                );

            ctx.commit('writeStatusList', response);

            return response;
        },
        async saveTripData(ctx, tripData) {
            await post(
                'api-morethantrip',
                'api/v1/trip/confirm',
                tripData,
                true
            );
        },
        async refuseTrip(ctx) {
            await post(
                'api-morethantrip',
                'api/v1/trip/refuseparticipation',
                {},
                true,
            );
        },
    },
    getters: {
        getTripCities: state => state.cities,
        getTripStatus: state => state.status,
        getTripStatusList: state => state.statusList,
        getActPdfLink: state => state.actPdfLink,
    },
};
